// extracted by mini-css-extract-plugin
export default {"container":"BenefitSuscriptionItem_container__b0DgI","checkContainer":"BenefitSuscriptionItem_checkContainer__wqcCY"};